const NotFoundPage = () => {
    return (
        <div className="container-form-2">
            <div className="d-flex justify-content-center">
                <span className="text" style={{ width: 'auto', height: 'auto' }}>No encontramos lo que buscabas</span>
            </div>
        </div>
    )
};

export default NotFoundPage;
